import './markdown-styles.css';

import TipsAndUpdatesOutlinedIcon from '@mui/icons-material/TipsAndUpdatesOutlined';
import { Button, Skeleton } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

import { OverviewStaticBlock } from '@/components/StaticBlock';
import { useGetAiProvidersQuery } from '@/services/graphql/hooks/generated';

const fetchAiResponse = async (
  apiUrl?: string,
  workflow?: string,
  personId?: string,
  providerName?: string,
  userId?: string,
  token?: string
) => {
  const url = `${apiUrl}/${workflow}?locale=en_US&person_id=${personId}&provider=${providerName}&user_id=${userId}`;
  try {
    const response = await fetch(url, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
      },
    });

    return await response.text();
  } catch (error) {
    console.error(error);
  }
};

type AiPersonInsightsType = {
  personId: string;
  userId: string;
};

export const AiPersonInsights = ({
  personId,
  userId,
}: AiPersonInsightsType) => {
  const { t } = useTranslation();
  const { data: aiProvidersData } = useGetAiProvidersQuery();
  const [loading, setLoading] = useState(false);
  const [hideButton, setHideButton] = useState(false);
  const [response, setResponse] = useState();

  const apiUrl = aiProvidersData?.ai?.url;
  const token = aiProvidersData?.ai?.token;
  const providers = aiProvidersData?.ai?.providers;
  const providerName = providers?.[0]?.name;
  const workflow = providers?.[0]?.workflows[0]?.workflow;

  const handleSubmit = () => {
    if (loading) {
      return;
    }
    setLoading(true);
    setHideButton(true);
    fetchAiResponse(
      apiUrl,
      workflow,
      personId,
      providerName,
      userId,
      token
    ).then((res) => {
      setLoading(false);
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      setResponse(res);
    });
  };

  return (
    <>
      <OverviewStaticBlock title={t('person.ai.title')}>
        {!hideButton && (
          <Button
            variant="outlined"
            style={{ width: '100%' }}
            startIcon={<TipsAndUpdatesOutlinedIcon />}
            onClick={handleSubmit}
          >
            {t('person.ai.generate.summary')}
          </Button>
        )}
        {loading && <StyledCard variant="rectangular" />}

        {!loading && (
          <div className={'markdown-body'}>
            <Markdown remarkPlugins={[remarkGfm]}>{response}</Markdown>
          </div>
        )}
      </OverviewStaticBlock>
    </>
  );
};

const StyledCard = styled(Skeleton, {
  shouldForwardProp: (prop) => prop !== 'isClickable',
})(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  margin: `${theme.spacing(5)}  0`,
}));
